import { createFileRoute } from '@tanstack/react-router'
import { ScoringChat } from '@/features/scoring/chat'

export const Route = createFileRoute(
  '/_authenticated/scoring/$conversationId/'
)({
  component: ScoringChat,
})
